import { CYLINDO_ACCOUNT_ID } from 'commons/constants';
import { CYLINDO_CONTENT_API } from './defaults';

// Builds Cylindo Content API image URLs (shared by usePDPCylindoViewer and
// useCylindoDimensionShots). `features` is a { FEATURE_KEY: code } map appended as
// repeated &feature=KEY:VAL segments. Keys and values can both contain spaces
// ("POWER OPTIONS", "2 RECLINER"), so both are URL-encoded.
const buildCylindoUrl = ({
  productId,
  kind = 'frames',
  frame,
  dimensionCode,
  size,
  features,
  version,
} = {}) => {
  const base = `${CYLINDO_CONTENT_API}/${CYLINDO_ACCOUNT_ID}/products/${productId}`;

  // Frames need the `/{productId}.png` filename: the bare `/frames/{frame}` form
  // returns a tiny default render, the `.png` form honors `size` and returns full-res.
  const path =
    kind === 'dimensions'
      ? `${base}/dimensions/${productId}.png`
      : `${base}/frames/${frame}/${productId}.png`;

  const query = [];

  if (size != null) {
    query.push(`size=${size}`);
  }

  if (kind === 'dimensions' && dimensionCode != null) {
    query.push(`dimensionCode=${dimensionCode}`);
  }

  if (features) {
    Object.entries(features).forEach(([featureKey, featureCode]) => {
      query.push(
        `feature=${encodeURIComponent(featureKey)}:${encodeURIComponent(
          featureCode
        )}`
      );
    });
  }

  if (version != null) {
    query.push(`version=${version}`);
  }

  return query.length ? `${path}?${query.join('&')}` : path;
};

export default buildCylindoUrl;
